import app from 'flarum/forum/app';
import {override} from 'flarum/common/extend';
import Discussion from 'flarum/common/models/Discussion';

export default function () {
    override(Discussion.prototype, 'replyCount', function (original) {
        // Flarum always subtract 1 from commentCount to calculate replyCount
        // But we know in all comment threads the first post isn't a comment and thus would throw off the count
        if (this.attribute('isWordpressComments')) {
            return this.commentCount();
        }

        return original();
    });

    override(Discussion.prototype, 'isUnread', function (original) {
        if (!this.attribute('isWordpressComments')) {
            return original();
        }

        const user = app.session.user;

        // Same as native, if user is logged out show all as read
        if (!user) {
            return false;
        }

        if ((user.markedAllAsReadAt()?.getTime() ?? 0) > this.lastPostedAt()?.getTime()!) {
            return false;
        }

        // Because the first (event) post doesn't count as a comment and because Flarum takes the lowest of commentCount and unreadCount
        // A WordPress discussion with no replies will always show as read despite having a post inside
        // We'll tweak the logic here so that Flarum still shows zero replies but shows the discussion as unread
        // We can skip all the unreadCount part since we only need true or false and not recompute any total
        return (this.lastPostNumber() ?? 0) > (this.lastReadPostNumber() || 0);
    });

    override(Discussion.prototype, 'isRead', function (original) {
        if (!this.attribute('isWordpressComments')) {
            return original();
        }

        if (!app.session.user) {
            return false;
        }

        return !this.isUnread();
    });
}
